import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

interface LoginCallback{
  (error: any, result?: any) : void;
}

interface LogoutCallback{
  (error: Error, result?: any) : void;
}

@Injectable()
export class AuthenticationService implements OnInit
{
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){}

    ngOnInit(){}
    login(credentials, callback: LoginCallback){
      var formData: FormData;
      formData = this.dataService.createFormData(credentials);
      this.http
      .post(
        Constants.API_BASE + "/usuarios/login",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        if(!data || data["status"] == 0){
          callback(data, undefined);
        } else {
          this.session.setIdToken(data["user"]["accessToken"]);
          this.session.setAccessToken(data["user"]["accessToken"]);
          this.session.setCurrentUser(data["user"]);
          sessionStorage.setItem('id_token', data["user"]["accessToken"]);
          sessionStorage.setItem('access_token', data["user"]["accessToken"]);
          sessionStorage.setItem('currentUser', JSON.stringify(data["user"]));
          callback(null, data["user"]["accessToken"]);
        }
      });
    }

    cambiarPass(credentials, callback: any){
      var formData: FormData;
      formData = this.dataService.createFormData(credentials);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/cambiarPass",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    logout(callback: LogoutCallback) {
        // remove user from local storage to log user out
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('currentUser');

        this.session.destroy();
        callback(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/auth.service.ts